// extracted by mini-css-extract-plugin
export var socialContainer = "styles-module--social-container--mwozo";
export var socialIcon = "styles-module--social-icon--g6eoH";